<template>
  <svg class="icon-home" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"></path>
  </svg>
</template>

<script>
  export default {
    name: 'IconHome',
  }
</script>
<style lang="scss">
  .icon-home{
    width: 45px;
    height: 40px;
    margin-bottom: 2px;
    color: var(--projectPrimaryColor);
    fill: currentColor;
  }
</style>